import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { SecurityService } from '../services/security.service';
import { catchError, map, of } from 'rxjs';
import { User } from '@app/models/user.model';

export const authenticationGuard: CanActivateFn = (route, state) => {
    const securityService: SecurityService = inject(SecurityService);
    const router: Router = inject(Router);
    const logger: NGXLogger = inject(NGXLogger);

    const user = securityService.getUser();
    if (user) {
        logger.debug('[AuthGuard] Utilisateur connecté, navigation autorisée', user);
        return true;
    }
    logger.debug('[AuthGuard] Utilisateur non connecté, session check', user);
    return securityService.authenticate().pipe(
        map((user: User | null) => {
            if (user) {
                logger.debug('[AuthGuard] session ok, navigation autorisée', user);
                return true;
            }
            router.navigate(['login'], { queryParams: { returnUrl: state.url } });
            return false;
        }),
        catchError(err => {
            logger.debug('[AuthGuard][Erreur] session ko, navigation refusée', err);
            router.navigate(['login'], { queryParams: { returnUrl: state.url } });
            return of(false);
        }),
    );
};
